// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0d774cc3","453":"9dbf54cb","455":"22578108","977":"25361c4a"}[chunkId] + ".chunk.js";
};